import { IItemCommercialTranslationState } from '@/store/itemcommercialtranslation';
import { IItemCommercialTranslationMutations } from './mutations.types';
import { IItemCommercialTranslationData } from '@/models';

export const mutations: IItemCommercialTranslationMutations = {
  SET_ITEM_COMMERCIAL_TRANSLATIONS(
    state: IItemCommercialTranslationState,
    payload: IItemCommercialTranslationData[]
  ): void {
    state.itemCommercialTranslations = payload;
  },

  ADD_ITEM_COMMERCIAL_TRANSLATION(
    state: IItemCommercialTranslationState,
    payload: IItemCommercialTranslationData
  ): void {
    state.itemCommercialTranslations.push(payload);
  },

  UPDATE_ITEM_COMMERCIAL_TRANSLATION(
    state: IItemCommercialTranslationState,
    payload: IItemCommercialTranslationData
  ): void {
    const index = state.itemCommercialTranslations.findIndex(
      (itemcommercialtranslation: IItemCommercialTranslationData) =>
        itemcommercialtranslation.id === payload.id
    );

    state.itemCommercialTranslations.splice(index, 1, payload);
  },

  REMOVE_ITEM_COMMERCIAL_TRANSLATION(
    state: IItemCommercialTranslationState,
    payload: number
  ): void {
    const index = state.itemCommercialTranslations.findIndex(
      (itemcommercialtranslation: IItemCommercialTranslationData) =>
        itemcommercialtranslation.id === payload
    );

    state.itemCommercialTranslations.splice(index, 1);
  },

  SET_COUNT(state: IItemCommercialTranslationState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IItemCommercialTranslationState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IItemCommercialTranslationState): void {
    state.count -= 1;
  }
};
